(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/personal-greeting-input.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/personal-greeting-input.js');
"use strict";

const _React = React,
  useMemo = _React.useMemo,
  useEffect = _React.useEffect;
const _svs$ui$reactForm = svs.ui.reactForm,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option;
const PersonalGreetingInput = _ref => {
  var _personalGreetingsOpt;
  let onInputChange = _ref.onInputChange,
    name = _ref.name,
    value = _ref.value;
  const personalGreetingsOptions = useMemo(() => (svs.tickets_giftshop.data.moduleConfig.greetings || []).filter(_ref2 => {
    let greeting = _ref2.greeting;
    return Boolean(greeting);
  }).map((_ref3, i) => {
    let greeting = _ref3.greeting;
    return {
      greeting,
      id: "".concat(greeting, "_").concat(i)
    };
  }));
  const hasOptions = (personalGreetingsOptions === null || personalGreetingsOptions === void 0 ? void 0 : personalGreetingsOptions.length) > 0;
  const defaultValue = hasOptions && ((_personalGreetingsOpt = personalGreetingsOptions[0]) === null || _personalGreetingsOpt === void 0 ? void 0 : _personalGreetingsOpt.greeting);
  useEffect(() => {
    const greetingExist = personalGreetingsOptions === null || personalGreetingsOptions === void 0 ? void 0 : personalGreetingsOptions.find(_ref4 => {
      let greeting = _ref4.greeting;
      return greeting === value;
    });
    if (!greetingExist) {
      onInputChange && onInputChange({
        target: {
          value: defaultValue,
          name
        }
      });
    }
  }, []);
  return hasOptions && React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    label: "V\xE4lj en rubrik",
    onChange: e => {
      onInputChange({
        target: {
          value: e.target.value,
          name
        }
      });
    },
    v2: true,
    value: value || defaultValue
  }, personalGreetingsOptions.map(_ref5 => {
    let greeting = _ref5.greeting,
      id = _ref5.id;
    return React.createElement(Option, {
      id: id,
      key: id,
      name: greeting,
      value: greeting
    }, greeting);
  })));
};
svs.tickets_giftshop.gift.giftform.components.PersonalGreetingInput = PersonalGreetingInput;

 })(window);